import { render, staticRenderFns } from "./abroad.vue?vue&type=template&id=2e7685b2&scoped=true"
import script from "./abroad.vue?vue&type=script&lang=js"
export * from "./abroad.vue?vue&type=script&lang=js"
import style0 from "./abroad.vue?vue&type=style&index=0&id=2e7685b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7685b2",
  null
  
)

export default component.exports